import { render, staticRenderFns } from "./PushData.vue?vue&type=template&id=bb64e382&"
import script from "./PushData.vue?vue&type=script&lang=js&"
export * from "./PushData.vue?vue&type=script&lang=js&"
import style0 from "./PushData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports